const ALLOWED_FILE_HOST = 'storage.googleapis.com'

// Guards against the success screen being rendered for an arbitrary url handed to us in the hash
function isAllowedFileUrl (fileUrl) {
  try {
    const url = new URL(fileUrl)
    return url.protocol === 'https:' && url.hostname === ALLOWED_FILE_HOST
  } catch (err) {
    return false
  }
}

function escapeHtml (value) {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')
}

function clearDownloadHash () {
  if (window.history && window.history.replaceState) {
    window.history.replaceState(null, document.title, window.location.pathname + window.location.search)
  }
}

function renderDownloadStartedScreen (fileName) {
  const subtitle = fileName ? `<div class="subtitle">${escapeHtml(fileName)}</div>` : ''
  document.body.innerHTML = `
    <style>
      html, body {
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
        background-color: #ffffff;
        color: #333333;
        text-align: center;
      }
      .container {
        padding: 24px;
      }
      .success-icon {
        font-size: 48px;
        color: #4caf50;
        margin-bottom: 16px;
      }
      .title {
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 8px;
      }
      .subtitle {
        font-size: 14px;
        color: #666666;
      }
    </style>
    <div class="container">
      <div class="success-icon">✓</div>
      <div class="title">Pengunduhan dokumen sudah dimulai, silahkan cek di menu unduh</div>
      ${subtitle}
    </div>
  `
}

// The object is served with Content-Disposition: attachment, so the browser downloads it
// on navigation; nothing is read in JS, which keeps this free of any CORS requirement
function handleLinkDownload (fileUrl, fileName) {
  if (!isAllowedFileUrl(fileUrl)) {
    return false
  }
  const link = document.createElement('a')
  link.href = fileUrl
  link.download = fileName || 'document'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

  clearDownloadHash()
  renderDownloadStartedScreen(fileName)
  return true
}

export function handleAndroidDownload () {
  const hash = window.location.hash.substring(1)
  if (hash && (hash.includes('data=') || hash.includes('fileUrl='))) {
    const params = {}
    const pairs = hash.split('&')
    for (let i = 0; i < pairs.length; i++) {
      const pair = pairs[i].split('=')
      if (pair.length === 2) {
        params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1])
      }
    }

    const { data: base64Data, fileName, mimeType, fileUrl } = params
    if (fileUrl) {
      return handleLinkDownload(fileUrl, fileName)
    }
    if (base64Data) {
      try {
        const byteCharacters = atob(base64Data)
        const byteArrays = []
        const sliceSize = 512
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          const slice = byteCharacters.slice(offset, offset + sliceSize)
          const byteNumbers = new Array(slice.length)
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i)
          }
          const byteArray = new Uint8Array(byteNumbers)
          byteArrays.push(byteArray)
        }
        const blob = new Blob(byteArrays, { type: mimeType || 'application/octet-stream' })
        const blobUrl = URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = blobUrl
        link.download = fileName || 'document'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        // Clear hash from URL immediately so bookmarking/refreshing doesn't re-trigger download
        clearDownloadHash()

        const isPdf = mimeType === 'application/pdf' || (fileName && fileName.toLowerCase().endsWith('.pdf'))
        if (isPdf) {
          document.title = fileName
          document.body.innerHTML = `
            <style>
              html, body {
                margin: 0;
                padding: 0;
                width: 100%;
                height: 100%;
                overflow: hidden;
                background-color: #ffffff;
              }
              iframe {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                border: none;
              }
            </style>
            <iframe src="${blobUrl}"></iframe>
          `
        } else {
          renderDownloadStartedScreen(fileName || 'document')
        }
        return true
      } catch (err) {
        console.error('Error handling direct download:', err)
      }
    }
  }
  return false
}
